export default "__VITE_ASSET__d968cc0e__"